import React, { useEffect } from 'react';
import AOS from 'aos';
import { Link } from 'react-router-dom';
import 'aos/dist/aos.css'; 
import { Helmet } from 'react-helmet';

const ExtraServices = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <>

<Helmet>
 
 <script type="application/ld+json">
   {JSON.stringify({
     "@context": "https://schema.org",
     "@type": "Organization",
     "name": "Om Sai PG",
     "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
     "url": "https://www.omsaipg.in",
     "logo": "https://www.omsaipg.in/images/logo.jpg",
     "image":"https://www.omsaipg.in/images/ogimage.jpg",
     "contactPoint": [
       {
         "@type": "ContactPoint",
         "telephone": "+91 9763888448",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
       {
         "@type": "ContactPoint",
         "telephone": "+91 9922248255",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
     ],
     "aggregateRating": {
       "@type": "AggregateRating",
       "bestRating": "5",
       "worstRating": "1",
       "ratingValue": "4.7",
       "ratingCount": "250",
     },
     "email": "omsaipg@gmail.com",
     "address": {
       "@type": "PostalAddress",
       "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
       "addressLocality": "Kharadi",
       "addressRegion": "Maharashtra",
       "postalCode": "411014",
       "addressCountry": "IN",
     },
     "sameAs": [
       "https://www.facebook.com/omsaipg",
       "https://www.instagram.com/omsaipg",
       "https://www.linkedin.com/company/omsaipg"
     ],
     "priceRange": "INR 8,500-6000",
     "paymentAccepted": "Cash, UPI, Credit Card",
     "telephone": "+91 9763888448",
     "email": "omsaipgpune@gmail.com",
     "keywords": [
       "PG in Pune",
       "PG in Kharadi",
       "PG with food in Pune",
       "PG for students in Kharadi",
       "PG for females in Pune",
       "PG for males in Pune",
       "Om Sai PG Kharadi",
       "Girls Hostels in Kharadi",
       "Boys Hostel in Kharadi",
       "Monthly Basis PG in Kharadi",
       "PG in Wagholi",
       "PG in Kharadi with food",
       "Hostels in Pune",
       "PG for Students in Kharadi Pune",
       "Paying Guest Hostel in Chandan Nagar"
     ],
     "openingHours": "Mo-Su 09:00-22:00"
   })}
 </script>

 {/* Title */}
 <title>
   Contact : +91 9763888448 / +91 9922248255 | Om Sai PG | Amenities | Girls Hostels in Kharadi | Boys Hostel in Kharadi | Monthly Basis PG in Kharadi |
PG in Wagholi
 </title>

 {/* Meta Tags */}
 <meta
   name="description"
   content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
 />
 <meta
   name="keywords"
   content="Girls Hostels in Kharadi,Boys Hostel in Kharadi,Monthly Basis PG in Kharadi,
PG in Wagholi"
 />
 <meta name="robots" content="index, follow" />

 {/* Open Graph Tags */}
 <meta
   property="og:title"
   content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi|Monthly Basis PG in Kharadi "
 />
 <meta
   property="og:description"
   content=" Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
 />
 <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
 <meta property="og:url" content="https://www.omsaipg.in" />
 <meta property="og:type" content="website" />
</Helmet>

    <section className="section-extra-services padding-tb-50">
      <div className="container">
        <div className="row">
          <div className="col-12" data-aos="fade-up" data-aos-duration="1000">
            <div className="rx-banner text-center rx-banner-effects">
              <p>
                <img
                  src="img/banner/left-shape.svg"
                  alt="banner-left-shape"
                  className="svg-img left-side"
                />
                Our Pricing
                <img
                  src="img/banner/right-shape.svg"
                  alt="banner-right-shape"
                  className="svg-img right-side"
                />
              </p>
              <h4>
                Other <span>Services</span>
              </h4>
            </div>
          </div>

          {/* First Service */}
          <div className="col-12 mb-minus-24">
            <div className="row" data-aos="fade-up" data-aos-duration="1000">
              <div className="col-md-3 col-sm-4 col-12 mb-24">
                <div className="extra-services-img">
                  <img src="img/rooms/room1.jpg" alt="extra-services-1" />
                </div>
              </div>
              <div className="col-md-9 col-sm-8 col-12 mb-24">
                <div className="extra-services-contact">
                  <div className="extra-services-absolute-contact">
                    <p>Om Sai PG</p>
                  </div>
                  <div className="rx-services-price">
                    <h2>
                     8,500 <span>/ Rs</span>
                    </h2>
                    <p>1 Sharing Room</p>
                  </div>
                  <div className="rx-services-inner-contact">
                    <ul>
                      <li>- High-Speed Internet</li>
                      <li>- 24/7 Security</li>
                      <li>- Common Kitchen & Dining Area</li>
                      <li>- Laundry Services</li>
                      <li>- Housekeeping & Maintenance</li>
                    </ul>
                  </div>
                  <div className="rx-services-ico">
                  <Link to="/enquiry" className="ico">
                      <i className="ri-arrow-right-up-line"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Second Service */}
            <div className="row" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
              <div className="col-md-3 col-sm-4 col-12 mb-24">
                <div className="extra-services-img">
                  <img src="img/rooms/room2.jpg" alt="extra-services-2" />
                </div>
              </div>
              <div className="col-md-9 col-sm-8 col-12 mb-24">
                <div className="extra-services-contact">
                  <div className="extra-services-absolute-contact">
                  <p>Om Sai PG</p>
                  </div>
                  <div className="rx-services-price">
                    <h2>
                      7000 <span>/ Rs</span>
                    </h2>
                    <p>2 Sharing Room</p>
                  </div>
                  <div className="rx-services-inner-contact">
                    <ul>
                      <li>- Washing Machine</li>
                      <li>- WiFi</li>
                      <li>- TV in Each Room</li>
                      <li>- 24/7 Water Supply</li>
                      <li>- Geyser</li>
                      <li>- Recreational Area</li>
                      <li>- Bed and Mattress</li>
                    </ul>
                  </div>
                  <div className="rx-services-ico">
                  <Link to="/enquiry" className="ico">
                      <i className="ri-arrow-right-up-line"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Third Service */}
            <div className="row" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="400">
              <div className="col-md-3 col-sm-4 col-12 mb-24">
                <div className="extra-services-img">
                  <img src="img/rooms/room3.jpg" alt="extra-services-3" />
                </div>
              </div>
              <div className="col-md-9 col-sm-8 col-12 mb-24">
                <div className="extra-services-contact">
                  <div className="extra-services-absolute-contact">
                  <p>Om Sai PG</p>
                  </div>
                  <div className="rx-services-price">
                    <h2>
                      6000 <span>/ Rs</span>
                    </h2>
                    <p>3 Sharing Room</p>
                  </div>
                  <div className="rx-services-inner-contact">
                    <ul>
                    <li>- 2-Wheeler Parking Available</li>
                      <li>- Fridge</li>
                      <li>- Gas Connection</li>
                      <li>- 24-Hour Hot Water</li>
                      <li>- Free Housekeeping</li>
                    </ul>
                  </div>
                  <div className="rx-services-ico">
                  <Link to="/enquiry" className="ico">
                      <i className="ri-arrow-right-up-line"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Fourth Service */}
            <div className="row" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="600">
              <div className="col-md-3 col-sm-4 col-12 mb-24">
                <div className="extra-services-img">
                  <img src="img/rooms/room4.jpg" alt="extra-services-4" />
                </div>
              </div>
              <div className="col-md-9 col-sm-8 col-12 mb-24">
                <div className="extra-services-contact">
                  <div className="extra-services-absolute-contact">
                  <p>Om Sai PG</p>
                  </div>
                  <div className="rx-services-price">
                    <h2>
                      6000 <span>/ Rs</span>
                    </h2>
                    <p>3 Sharing Room</p>
                  </div>
                  <div className="rx-services-inner-contact">
                    <ul>
                    <li>- Free Electricity Bill</li>
                      <li>- Purified Drinking Water</li>
                      <li>- CCTV Surveillance</li>
                      <li>- Air-Conditioning (Optional)</li>
                      <li>- Power Backup</li>
                    </ul>
                  </div>
                  <div className="rx-services-ico">
                    <Link to="/enquiry" className="ico">
                      <i className="ri-arrow-right-up-line"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default ExtraServices;
